import React, { useRef, useState, useEffect } from 'react'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import ConflictDropdown from 'duties/filters/conflict-dropdown'
import RoleDropdown from 'duties/filters/role-dropdown'
import Search from 'shared/forms/search'
import DepartmentDropdown from 'shared/department-dropdown'
import TerminatedToggle from 'duties/filters/terminated-toggle'
import InactiveUsersToggle from 'duties/filters/inactive-users'
import MissingPayroll from 'duties/filters/missing-payroll'
import NoDataAccessToggle from 'duties/filters/no-data-access'
import SystemUsersToggle from 'duties/filters/system-users-toggle'
import Popover from 'react-bootstrap/Popover'
import Overlay from 'react-bootstrap/Overlay'
import IndexActionsDropdown from 'duties/employees/IndexActionsDropdown'
import CompareUsersModal from 'duties/employees/CompareUsersModal'

function Filters({ filterParams, setFilterParams, dataType = 'Role' }) {
  const [show, setShow] = useState(false)
  const [showCompare, setShowCompare] = useState(false)
  const target = useRef(null)
  const isFiltered =
    !filterParams.active ||
    filterParams.missingPayroll ||
    filterParams.terminated ||
    filterParams.noDataAccess ||
    filterParams.showSystem

  useEffect(() => {
    if (filterParams.missingPayroll) {
      setFilterParams((prev) => ({
        ...prev,
        active: true,
        terminated: false
      }))
    }
  }, [filterParams.missingPayroll, setFilterParams])

  useEffect(() => {
    if (!filterParams.active) {
      setFilterParams((prev) => ({
        ...prev,
        missingPayroll: false,
        terminated: false
      }))
    }
  }, [filterParams.active, setFilterParams])

  useEffect(() => {
    if (filterParams.terminated) {
      setFilterParams((prev) => ({
        ...prev,
        missingPayroll: false,
        active: true
      }))
    }
  }, [filterParams.terminated, setFilterParams])

  return (
    <>
      <Row className="mb-4 mt-2">
        <Col sm={2}>
          <Search params={filterParams} setParams={setFilterParams} />
        </Col>

        <Col sm={2}>
          <DepartmentDropdown
            params={filterParams}
            setParams={setFilterParams}
          />
        </Col>
        <Col sm={2}>
          <RoleDropdown
            filterParams={filterParams}
            setFilterParams={setFilterParams}
          />
        </Col>
        <Col sm={2}>
          <ConflictDropdown
            filterParams={filterParams}
            setFilterParams={setFilterParams}
          />
        </Col>
        <>
          <Col sm="auto">
            <Overlay
              target={target.current}
              show={show}
              placement="bottom"
              rootClose
              onHide={() => setShow(false)}
            >
              <Popover id="more-filters-popover">
                <Popover.Body>
                  <MissingPayroll
                    params={filterParams}
                    setParams={setFilterParams}
                  />
                  <InactiveUsersToggle
                    params={filterParams}
                    setParams={setFilterParams}
                  />
                  <TerminatedToggle
                    params={filterParams}
                    setParams={setFilterParams}
                  />
                  <SystemUsersToggle
                    params={filterParams}
                    setParams={setFilterParams}
                  />
                  {false && (
                    <NoDataAccessToggle
                      params={filterParams}
                      setParams={setFilterParams}
                    />
                  )}
                  <hr />
                  <button
                    className="btn btn-primary btn-sm"
                    onClick={() => setShow(false)}
                  >
                    Close
                  </button>
                </Popover.Body>
              </Popover>
            </Overlay>
            <button
              className={`btn bg-white ${
                isFiltered ? 'border-primary text-primary' : 'btn-light'
              }`}
              style={{ border: isFiltered ? '' : '1px solid #ccc' }}
              ref={target}
              onClick={() => setShow(!show)}
            >
              More Filters
            </button>
          </Col>
          <Col sm="auto" className="ms-auto">
            <IndexActionsDropdown
              filterParams={filterParams}
              onCompare={() => setShowCompare(true)}
            />
          </Col>
        </>
      </Row>

      <CompareUsersModal show={showCompare} setShow={setShowCompare} />
    </>
  )
}

export default Filters
